module.exports = __webpack_public_path__ + "static/media/address.607dfbf3.svg";